angular.module('unergie.main')
.controller('energyCheckHistoryModalCtrl', ($scope, $uibModalInstance, BoFeaturesService, DataAccess, ApiBilling, AlertManager, ErrorCatcher, NgTableParams, ApiUser, account) => {
    $scope.isFeatureOn = BoFeaturesService.isFeatureOn
    $scope.canCheckToRegenMisc = BoFeaturesService.isFeatureOn('canCheckToRegenMisc')
    $scope.potExplain = {}
    $scope.tables = {}
    $scope.historyFetched = false

    $scope.close = () => {
        $uibModalInstance.dismiss()
    }

    $scope.isValid = (check) => {
        return moment(check.validity_date).isAfter(moment())
    }

    $scope.fetchHistory = () => {
        if ($scope.fetchingECHistory || $scope.historyFetched) {
            return
        }
        $scope.fetchingECHistory = true
        return DataAccess.fetchEnergyCheckHistory({ id_account: account.id }).$promise.then((historyResults) => {
            $scope.checksHistoryTable = new NgTableParams({ sorting: { payment_date: 'desc' }, count: 10 }, { dataset: historyResults, counts: [] })
            $scope.historyFetched = true
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.fetchingECHistory = false
        })
    }

    $scope.checkToRegenMisc = () => {
        $scope.checkingToRegenMisc = true
        return ApiBilling.checkToRegenMisc({}, { limit: 10, id_account: account.id }).$promise.then((result) => {
            AlertManager.success(`${result.nbInvoices} factures relancée(s)`)
        }).catch(ErrorCatcher)
        .finally(() => {
            $scope.checkingToRegenMisc = false
        })
    }

    const activate = () => {
        $scope.checksTable = new NgTableParams({ sorting: { validity_date: 'desc' }, count: 10 }, { dataset: account.energyChecks, counts: [] })
    }

    activate()
})
